import { render, staticRenderFns } from "./OrderChart.vue?vue&type=template&id=caf83256"
import script from "./OrderChart.vue?vue&type=script&lang=js"
export * from "./OrderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf83256')) {
      api.createRecord('caf83256', component.options)
    } else {
      api.reload('caf83256', component.options)
    }
    module.hot.accept("./OrderChart.vue?vue&type=template&id=caf83256", function () {
      api.rerender('caf83256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/OrderChart.vue"
export default component.exports